export interface DecisionListItem {
	ruleKey: string | null;
	variationKey: string | null;
	experimentId?: string;
	variationId?: string;
}

// `name(id)`, or bare name when the id is missing.
function withId(name: string | null, id?: string): string {
	const safeName = name ?? '';
	return id ? `${safeName}(${id})` : safeName;
}

// Adobe `list1` segment for one decision: `ruleKey(experimentId):variationKey(variationId)`.
export function formatDecision({
	ruleKey,
	variationKey,
	experimentId,
	variationId,
}: DecisionListItem): string {
	return `${withId(ruleKey, experimentId)}:${withId(variationKey, variationId)}`;
}

export function buildListVar(items: DecisionListItem[]): string {
	return items.map(formatDecision).join('|');
}
